import { FileIcon } from "../../icons/FileIcon";

type FileItemPreviewProps = {
	url: string;
	type: string;
	name: string;
};

export const FileItemPreview = ({ url, type, name }: FileItemPreviewProps) => {
	if (type.includes("image")) {
		return <img height={100} alt={name} className="h-[100px] max-w-xs rounded-lg object-contain" src={url} />;
	}

	return (
		<div className="flex flex-col items-center gap-2 rounded-lg border border-neutral-faded p-4">
			<FileIcon className="h-5 min-h-5 w-5 min-w-5" />
			<span className="text-neutral-faded text-sm">{name}</span>
		</div>
	);
};
